function EyeIcon(props) {
  const { 
    className, 
    color= '#727580', 
    height= 8, 
    width=13
  } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      < path 
        d="M6.49941 6.8446C7.58012 6.8446 8.60234 6.58694 9.56374 6.07163C10.5263 5.55633 11.3333 4.8654 11.9871 4.00115C11.3333 3.13576 10.5251 2.44598 9.56374 1.93068C8.60234 1.41537 7.58012 1.15771 6.49941 1.15771C5.41871 1.15771 4.39649 1.41537 3.43509 1.93068C2.47368 2.44598 1.6655 3.13691 1.0117 4.00115C1.6655 4.86655 2.47368 5.55633 3.43509 6.07163C4.39649 6.58694 5.41871 6.8446 6.49941 6.8446ZM6.49941 5.1554C6.17661 5.1554 5.90175 5.04217 5.67251 4.81687C5.44327 4.59041 5.32982 4.31889 5.32982 4C5.32982 3.68111 5.44444 3.40959 5.67251 3.18313C5.90175 2.95783 6.17661 2.8446 6.49941 2.8446C6.82222 2.8446 7.09707 2.95783 7.32631 3.18313C7.55555 3.40959 7.66901 3.68111 7.66901 4C7.66901 4.31889 7.55438 4.59041 7.32631 4.81687C7.09707 5.04217 6.82222 5.1554 6.49941 5.1554ZM6.49941 8C5.27485 8 4.12982 7.73426 3.06316 7.20393C1.99766 6.6736 1.08538 5.93645 0.327485 4.99133C0.210526 4.84691 0.126315 4.69324 0.0760229 4.52802C0.0257305 4.3628 0 4.19642 0 4.02888C0 3.86135 0.0257305 3.68689 0.0760229 3.50433C0.127485 3.32178 0.210526 3.15656 0.327485 3.00867C1.08655 2.06355 1.99766 1.3264 3.06316 0.796072C4.12865 0.265743 5.27368 0 6.49941 0C7.72515 0 8.87018 0.265743 9.93567 0.796072C11.0012 1.3264 11.9135 2.06355 12.6725 3.00867C12.7895 3.15656 12.8737 3.31716 12.924 3.48931C12.9743 3.66147 13 3.83247 13 4C13 4.16753 12.9743 4.33738 12.924 4.50953C12.8725 4.68169 12.7895 4.84229 12.6725 4.99133C11.9135 5.93645 11.0012 6.6736 9.93567 7.20393C8.87018 7.73426 7.72515 8 6.49941 8Z" 
        fill={color}
      />
    </svg>
  );
}

export { EyeIcon };
